let posthogClient: any;
let posthogLoadPromise: Promise<any>;

export function getPosthog(): any {
  return posthogClient;
}

export function loadPosthog(): Promise<any> {
  if (!posthogLoadPromise) {
    posthogLoadPromise = import('posthog-js').then(({ default: client }) => {
      posthogClient = client;
      return client;
    });
  }

  return posthogLoadPromise;
}
